module.exports = __webpack_public_path__ + "static/img/logo_mobile.0446f74b.png";